import { getResourceFromS3 } from "@/utils/getResourceFromS3"
import type { Social } from "../types/widget.props"

interface ListaRedesProps {
    social?: Social
    lojaNome?: string
}

export function ListaRedes({ social, lojaNome }: Readonly<ListaRedesProps>) {
    const socialConfig = [
        {
            key: "pinterest",
            label: "Pinterest",
            icon: "icon-pinterest.svg"
        },
        {
            key: "youtube",
            label: "YouTube",
            icon: "icon-youtube.svg"
        },
        {
            key: "facebook",
            label: "Facebook",
            icon: "icon-facebook.svg"
        },
        {
            key: "instagram",
            label: "Instagram",
            icon: "icon-instagram.svg"
        },
        {
            key: "twitter",
            label: "Twitter",
            icon: "icon-twitter.svg"
        },
        {
            key: "tiktok",
            label: "Tiktok",
            icon: "icon-tiktok.svg"
        }
    ] as const

    return (
        <ul className="lista-redes flex center align-center">
            {socialConfig.map(({ key, label, icon }) => {
                const url = social?.[key]
                if (!url) return null

                return (
                    <li key={key}>
                        <a
                            href={url}
                            title={`${lojaNome} no ${label}`}
                            target="_blank"
                            rel="nofollow noopener"
                        >
                            <img
                                src={getResourceFromS3('/assets/global/common-icons/social-icons', icon)}
                                width={30}
                                height={30}
                                alt={label}
                                title={label}
                                draggable={false}
                            />
                        </a>
                    </li>
                )
            })}
        </ul>
    )
}
